import { realtimeDb, firestoreDb, firebaseAuth } from '../config/constants'
import firebase from 'firebase';
import log from '../helpers/logger'

export function getIssueList(){

  let dataList = []
  return firestoreDb.collection("issue").orderBy("date_created", "desc").get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function getIssueListByMagazineId(id){

  let dataList = []
  var fRef = firestoreDb.collection("issue")
  var query = fRef.where("magazine_id", "==", id).orderBy("date_created", "desc")

  return query.get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        //console.log(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function getIssueListByStatus(status){

  let dataList = []
  var fRef = firestoreDb.collection("issue")
  var query = fRef.where("status", "==", status).orderBy("date_created", "desc")

  return query.get().then(function(querySnapshot) {
    let count = 0;
    querySnapshot.forEach(function(doc) {
        //console.log(doc.id, " => ", doc.data());
        dataList.push(doc)
        count = count+1
        if(count === querySnapshot.size){
          return dataList
        }
    });
  }).then(() => dataList);
}

export function updateIssueCoverInfo (id, cover_width, cover_height, cover_url) {
  return firestoreDb.collection("issue").doc(id).update({
    cover_width: String(cover_width),
    cover_height: String(cover_height),
    cover_url: cover_url,
    })
}

export function updateIssueBookDownloadInfo (id, book_download_url) {
  return firestoreDb.collection("issue").doc(id).update({
    book_download_url: book_download_url,
    })
}

export function updateIssue (id, issue) {
  return firestoreDb.collection("issue").doc(id).update({

    issue_uuid: issue.issue_uuid,
    magazine_id: issue.magazine_id,
    magazine_uuid: issue.magazine_uuid,
    owner_id: issue.owner_id,
    tag: issue.tag,
    title: issue.title,
    description: issue.description,
    is_publish: issue.is_publish,
    issue_version: issue.issue_version,
    cover_width: issue.cover_width,
    cover_height: issue.cover_height,
    cover_url: issue.cover_url,
    issue_download_url: issue.issue_download_url,
    download_success_msg_title: issue.download_success_msg_title,
    download_success_msg_body: issue.download_success_msg_body,
    notify_cover_number: issue.notify_cover_number,
    share_text: issue.share_text,
    embed_html: issue.embed_html,
    date_released: issue.date_released,
    date_modified: issue.date_modified,
    date_created: issue.date_created,
    status: issue.status,
    }).then(() => issue)
}

export function getIssue (id) {

  return firestoreDb.collection("issue").doc(id).get().then(function(doc) {
    if (doc.exists) {
        return doc.data();
    } else {
        return null
    }
  });

}

export function deleteIssue (id) {
  let issue = null
  return firestoreDb.collection("issue").doc(id).update({
    status: 'D'
    }).then(() => issue)
}

export function createIssue (issue) {
  //setup date_created from firebase server.
  issue.date_created = firebase.firestore.FieldValue.serverTimestamp()

  return firestoreDb.collection("issue").add({

    issue_uuid: issue.issue_uuid,
    magazine_id: issue.magazine_id,
    magazine_uuid: issue.magazine_uuid,
    owner_id: issue.owner_id,
    tag: issue.tag,
    title: issue.title,
    description: issue.description,
    is_publish: issue.is_publish,
    issue_version: issue.issue_version,
    cover_width: issue.cover_width,
    cover_height: issue.cover_height,
    cover_url: issue.cover_url,
    issue_download_url: issue.issue_download_url,
    download_success_msg_title: issue.download_success_msg_title,
    download_success_msg_body: issue.download_success_msg_body,
    notify_cover_number: issue.notify_cover_number,
    share_text: issue.share_text,
    embed_html: issue.embed_html,
    date_released: issue.date_released,
    date_modified: issue.date_modified,
    date_created: issue.date_created,
    status: issue.status,
    }).then(() => issue)

}



// WEBPACK FOOTER //
// ./src/services/IssueService.js